"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeOrder = exports.initializeOrderWithConnection = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const state_1 = require("../state");
const util_1 = require("../util");
const createOpenOrdersCounter_1 = require("./createOpenOrdersCounter");
/**
 * Creates a new buy/sell order with Solana connection
 * Takes a connection to fetch necessary accounts - it is preferred to use `initializeOrder`
 * if account data can be provided without an RPC connection.
 * @param connection - the Solana connection
 * @param side - Order side
 * @param orderInitializer - AsyncSigner creating the order
 * @param price - price In base units
 * @param originationQty - Quantity to sell or buy
 * @param itemMint - the mint of the item being sold or bought
 * @param currencyMint - The currency, must be registered already with the program
 * @param program - GalacticMarketplace Program
 * @returns InstructionReturn
 */
function initializeOrderWithConnection(connection, side, orderInitializer, price, originationQty, itemMint, currencyMint, program) {
    return __awaiter(this, void 0, void 0, function* () {
        const instructionArray = [];
        const depositMint = side === 'sell' ? itemMint : currencyMint;
        const receiveMint = side === 'sell' ? currencyMint : itemMint;
        /**
         * This makes the assumption that the deposit token account ATA exists
         * Which it should, if the user is trying to transact the deposit token
         */
        const { tokenAccount: depositTokenAccount } = yield (0, util_1.getTokenAccount)(connection, orderInitializer.publicKey(), depositMint);
        const initializerDepositTokenAccountAddress = 'publicKey' in depositTokenAccount
            ? depositTokenAccount.publicKey
            : depositTokenAccount;
        let initializerReceiveTokenAccount;
        const receiveAtaResponse = yield (0, util_1.getTokenAccount)(connection, orderInitializer.publicKey(), receiveMint);
        const receiveTokenAccount = receiveAtaResponse.tokenAccount;
        if ('createInstruction' in receiveAtaResponse) {
            instructionArray.push(receiveAtaResponse.createInstruction);
        }
        if (receiveTokenAccount instanceof web3_js_1.Keypair) {
            initializerReceiveTokenAccount = receiveTokenAccount.publicKey;
        }
        else {
            initializerReceiveTokenAccount = receiveTokenAccount;
        }
        // Get open order counter, initializing if necessary
        const [openOrdersCounterAddress] = state_1.OpenOrdersCounter.findAddress(program, orderInitializer.publicKey(), depositMint);
        const orderCounter = yield connection.getAccountInfo(openOrdersCounterAddress);
        if (orderCounter === null) {
            const createOpenOrderCounterInstruction = (0, createOpenOrdersCounter_1.createOpenOrdersCounter)(program, orderInitializer.publicKey(), depositMint);
            instructionArray.push(createOpenOrderCounterInstruction);
        }
        // Generate order account
        const orderAccount = web3_js_1.Keypair.generate();
        const orderAccountInitializeInstruction = yield (0, util_1.createOrderAccountInstruction)(connection, program, orderAccount);
        instructionArray.push(orderAccountInitializeInstruction);
        const orderInstruction = initializeOrder(side, program, orderAccount.publicKey, price, originationQty, initializerDepositTokenAccountAddress, initializerReceiveTokenAccount, depositMint, receiveMint, currencyMint, orderInitializer, openOrdersCounterAddress);
        instructionArray.push(orderInstruction);
        return {
            orderAccount: orderAccount.publicKey,
            instructions: instructionArray,
        };
    });
}
exports.initializeOrderWithConnection = initializeOrderWithConnection;
/**
 * Creates a new buy/sell order
 * @param side - Order side
 * @param program - GalacticMarketplace Program Anchor program
 * @param orderAccount - The publicKey of the order account created for this order, must exist already
 * @param price - The price in base units
 * @param originationQty - Quantity to sell or buy in base units
 * @param initializerDepositTokenAccount - depositMint token account
 * @param initializerReceiveTokenAccount - receiveMint token account
 * @param depositMint - What the user is depositing, e.g. currency if buying, item if selling
 * @param receiveMint - What the user wants in exchange, e.g. item if buying, currency if selling
 * @param currencyMint - The currency, must be registered already in the program
 * @param orderInitializer - AsyncSigner creating the order
 * @param openOrdersCounter - Should exist for the depositMint
 * @returns InstructionReturn
 */
function initializeOrder(side, program, orderAccount, price, originationQty, initializerDepositTokenAccount, initializerReceiveTokenAccount, depositMint, receiveMint, currencyMint, orderInitializer, openOrdersCounter) {
    const orderVaultAccount = state_1.Order.getOrderVaultAddress(program, orderInitializer.publicKey(), depositMint)[0];
    const orderVaultAuthority = state_1.Order.getOrderVaultAuthorityAddress(program, orderInitializer.publicKey())[0];
    const marketVarsAccount = state_1.MarketVars.findAddress(program)[0];
    const registeredCurrency = state_1.RegisteredCurrency.findAddress(program, currencyMint)[0];
    const programMethod = side === 'buy'
        ? program.methods.processInitializeBuy
        : program.methods.processInitializeSell;
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield programMethod(price, new anchor_1.BN(originationQty))
                .accountsStrict({
                orderVaultAccount,
                orderVaultAuthority,
                orderInitializer: orderInitializer.publicKey(),
                marketVarsAccount,
                depositMint,
                receiveMint,
                initializerDepositTokenAccount,
                initializerReceiveTokenAccount,
                orderAccount,
                registeredCurrency,
                openOrdersCounter,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            })
                .instruction(),
            signers: [orderInitializer],
        });
    });
}
exports.initializeOrder = initializeOrder;
//# sourceMappingURL=processOrder.js.map